export type Flags = {
  github?: boolean
  previewCoding?: boolean
  alertError?: boolean
  regeneration?: boolean
  intercom?: boolean
  share?: boolean
  v3LaunchWaitlist?: boolean
  v3LaunchVideo?: boolean
}

export const localFlags: Flags = {
  alertError: process.env.NEXT_PUBLIC_ALERT_ERROR === 'true',
}

export const getFlags = async (): Promise<Flags> => {
  // For avoiding the fucking GFW blocking the edge config
  const disableFeatureFlags = process.env.DISABLE_FEATURE_FLAGS === 'true'

  let remoteFlags: Flags = {}

  if (!disableFeatureFlags && process.env.EDGE_CONFIG) {
    try {
      const { get } = await import('@vercel/edge-config')
      remoteFlags = (await get<Flags>('flags')) || {}
    } catch (error) {
      // Silently fail in local development if edge-config is not available
      console.warn('Edge config not available, using local flags only:', error)
    }
  }

  const flags = { ...remoteFlags, ...localFlags }

  return flags
}
